import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, Alert } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const GroceryMobileShare = () => {
    const [searchParams] = useSearchParams();
    const [listText, setListText] = useState('');
    const [title, setTitle] = useState('GROCERY LIST');
    const [themeColor, setThemeColor] = useState('#ed8936');
    const [copySuccess, setCopySuccess] = useState(false);

    useEffect(() => {
        // Get params from URL
        const encodedList = searchParams.get('list');
        const paramTitle = searchParams.get('title');
        const paramColor = searchParams.get('color');

        if (encodedList) {
            try {
                // Decode URI component (handle multiple layers if needed)
                setListText(decodeURIComponent(encodedList));
            } catch (e) {
                console.error('Failed to decode list', e);
                setListText('Error decoding list.');
            }
        }

        if (paramTitle) {
            try {
                setTitle(decodeURIComponent(paramTitle).toUpperCase());
            } catch (e) {}
        }

        if (paramColor) {
            try {
                setThemeColor(decodeURIComponent(paramColor));
            } catch (e) {}
        }
    }, [searchParams]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(listText);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 3000);
        } catch (err) {
            console.error('Failed to copy', err);
            // Fallback for some mobile browsers if needed?
            // Usually modern browsers support clipboard API in secure contexts
        }
    };

    return (
        <Box 
            sx={{ 
                minHeight: '100vh', 
                bgcolor: '#f7fafc',
                py: 4
            }}
        >
            <Container maxWidth="sm">
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography variant="h4" fontWeight="900" color={themeColor} gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Review and copy to your phone
                    </Typography>
                </Box>

                <Paper 
                    elevation={0}
                    sx={{ 
                        p: 3, 
                        borderRadius: 4, 
                        border: '1px solid #e2e8f0',
                        bgcolor: 'white',
                        mb: 4
                    }}
                >
                    <pre style={{ 
                        whiteSpace: 'pre-wrap', 
                        fontFamily: 'inherit',
                        fontSize: '1.1rem',
                        margin: 0,
                        color: '#2d3748'
                    }}>
                        {listText || "No items found in link."}
                    </pre>
                </Paper>

                <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    onClick={handleCopy}
                    startIcon={copySuccess ? <CheckCircleIcon /> : <ContentCopyIcon />}
                    sx={{
                        py: 2.5,
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        borderRadius: 3,
                        bgcolor: copySuccess ? '#48bb78' : themeColor,
                        '&:hover': {
                            bgcolor: copySuccess ? '#38a169' : themeColor // Simple hover, could darken
                        },
                        boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)'
                    }}
                >
                    {copySuccess ? "COPIED TO CLIPBOARD!" : "COPY TO CLIPBOARD"}
                </Button>

                {copySuccess && (
                    <Alert severity="success" sx={{ mt: 3, borderRadius: 2 }}>
                        Text copied! Switch to Google Keep or Notes to paste it.
                    </Alert>
                )}

            </Container>
        </Box>
    );
};

export default GroceryMobileShare;
